module.exports = __webpack_public_path__ + "static/media/b-sci-major-37_LR.607590b8.jpg";